import { Box, Typography, Grid, Container } from "@mui/material";
import { Link } from "react-router-dom";
type MenuItem = {
  icon: React.ReactNode;
  title: string;
  description: string;
  link?: string; 
};

export default function FloatingMegaMenu({ items }: { items: MenuItem[] }) {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 5 }}>
        <Grid container spacing={4}>
  {items.map((item) => (
    <Grid key={item.title} size={{ xs: 12, md: 4 }}>
      <Box
        component={Link}
        to={item.link || "#"}
        sx={{
          display: "flex",
          gap: 2,
          textDecoration: "none",
          color: "inherit",
          p: 2,
          borderRadius: 2,
          transition: "0.25s",

          "&:hover": {
            backgroundColor: "#f1f5f9",
            transform: "translateY(-2px)",
          },
        }}
      >
        {item.icon}

        <Box>
          <Typography fontWeight={600}>{item.title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {item.description}
          </Typography>
        </Box>
      </Box>
    </Grid>
  ))}
</Grid>
      </Box>
    </Container>
  );
}
